import { render, staticRenderFns } from "./TokenRewards.vue?vue&type=template&id=09292e4b"
import script from "./TokenRewards.vue?vue&type=script&lang=js"
export * from "./TokenRewards.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports